import type { TextStyle, ViewStyle } from 'react-native'
import { tv } from 'tailwind-variants'

import { BORDER_RADIUS, COLOR, ICON_SIZE, SPACE } from '@ui-kit/constants'
import { caption } from '@ui-kit/core/typography'

import type { CodeStatus, StatusColorMap } from './types'

export const STATUS_COLORS: StatusColorMap = {
  VERIFIED: COLOR.deepForest,
  INVALID: COLOR.error,
}

export const getContainerStyles = (align: 'center' | 'start' = 'center'): ViewStyle => ({
  justifyContent: align === 'start' ? 'flex-start' : 'center',
  columnGap: SPACE.mini,
})

export const focusStyles: TextStyle = {
  borderColor: COLOR.deepForest,
}

export const selectionColor = COLOR.black

export const disabledCodeTextStyle: TextStyle = {
  opacity: 1,
}

export const getInputStyles = (
  codeStatus: CodeStatus | undefined,
  isSecure: boolean
): TextStyle => {
  return {
    textAlign: 'center',
    color: codeStatus ? STATUS_COLORS[codeStatus] : COLOR.black,
    fontSize: isSecure === true ? 25 : 16,
  }
}

export const getFocusStickStyles = (codeStatus?: CodeStatus): ViewStyle => ({
  height: SPACE.small,
  width: BORDER_RADIUS.xsmall,
  alignItems: 'center',
  backgroundColor: codeStatus ? STATUS_COLORS[codeStatus] : COLOR.deepForest,
})

export const getInputContainerStyles = (codeStatus: CodeStatus | undefined): ViewStyle => {
  return {
    borderRadius: BORDER_RADIUS.normal,
    width: ICON_SIZE.large,
    height: SPACE.xlarge,
    borderWidth: 1.0,
    borderColor: codeStatus ? STATUS_COLORS[codeStatus] : COLOR.grey300,
  }
}

export const errorMessage = tv({
  base: [caption({ color: 'error' }), 'pt-1 text-center'],
})
